import BaseStore from './BaseStore';
import rp from 'request-promise';
import _ from 'lodash';
import config from '../config';
import { getToken } from '../components/Token';
import { clearLocalStorage } from '../utils/common';
import { getTenantHeaders } from '../components/TenantHeaders';

const defaultData = {
  moduleId: null, //392
  name: '',
};

export class SubGroupStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      subGroups: [],
      ListSubGroups: [],
      allSubgroups: [],
      subGroupsInfo: [],
      modules: [],
      data: _.cloneDeep(defaultData),
      tenantIds: null,
      offset: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      action: null,
    });
  }

  changeData(key, value) {
    this.data[key] = value;
  }

  changeMultipleDataInModule(key, value, index) {
    this.modules[index][key] = value;
  }

  setModules(data) {
    this.modules = data;
  }

  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.tenantIds = null;
  }

  resetSubgroup() {
    this.subGroups = [];
  }

  async setData(task, data, getSubGroup = true) {
    this[task] = data;
    if (getSubGroup) {
      this.getSubGroup(this.offset, this.limit, this.search, this.sort, this.order, this.tenantIds);
    }
  }

  async setSubGroup(data) {
    this.ListSubGroups = data;
  }

  async getSubGroup(offset = 0, limit = 15, search = null, sort = null, order = null, tenantIds = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/subgroup`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const subGroups = res.body || {};
        return (this.subGroups = subGroups);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getSubGroupSelect(tenantId) {
    this.loading = true;
    let queryOption = {};
    queryOption.tenantId = tenantId;
    try {
      let url = `${config.api.url}/${config.api.version}/subgroup/list/all`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const subGroups = res.body || {};
        return (this.allSubgroups = subGroups);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getSubGroupByGroupID(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/subgroup/${id}/group`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const ListSubGroups = res.body || {};
        this.ListSubGroups = ListSubGroups;
        return this.ListSubGroups;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getBasicSubgroupInfoByTenantId(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/subgroup/basic/info/tenant/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const subGroups = res.body || {};
        this.subGroupsInfo = subGroups;
        return subGroups;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      };
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getSubgroupById(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/subgroup/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const subGroups = res.body || {};
        // this.subGroups = subGroups;
        return subGroups;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getSubgroupByIds(ids) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/subgroup/basicinfo`;
      const res = await rp
        .post(url, {
          body: {
            subgroups: ids,
          },
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const subGroups = res.body || {};
        return subGroups;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getSubgroupByGroupIds(groupsIds) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/subgroup/groups`;
      const res = await rp
        .post(url, {
          body: {
            groups: groupsIds,
          },
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const subGroups = res.body || {};
        return subGroups;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createSubGroup(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        tenantId: data.tenantId,
        mapId: data.mapId,
        type: data.type,
        description: data.description,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/subgroup`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        if (data.mapId) {
          let result = await this.assignMap(data.mapId, res.body.id);
          return result;
        }
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateSubGroup(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        tenantId: data.tenantId,
        mapId: data.mapId,
        type: data.type,
        description: data.description,
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/subgroup/${data.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        if (data.mapId) {
          let response = await this.assignMap(data.mapId, data.id);
          return response;
        }
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createMultipleSubgroups(groupId, data) {
    this.loading = true;
    try {
      const detail = {
        groupId: groupId,
        subgroups: data,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/subgroup/chunk`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateSubgroups(data) {
    this.loading = true;
    try {
      const detail = {
        groups: data,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/subgroup/update/current`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async assignMap(mapId, subGroupId) {
    this.loading = true;
    try {
      const detail = {
        subgroupId: subGroupId,
        mapId: mapId === ' ' ? null : mapId,
      };
      let url = `${config.api.url}/${config.api.version}/subgroup/map/assign`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async unassign(id) {
    console.log('subgroup unassign');
    this.loading = true;
    try {
      // get bed by subgroup id
      const resBed = await rp
        .get(`${config.api.url}/${config.api.version}/bed/subgroup/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      const beds = resBed && resBed.statusCode === 200 ? resBed.body : [];
      for (const bed of beds) {
        if (bed.patient) {
          // unassigned device from patients
          for (const device of bed.patient.devices || []) {
            await rp
              .post(`${config.api.url}/${config.api.version}/device/unassign`, {
                body: { device_id: device.id },
                json: true,
                authorization: true,
                resolveWithFullResponse: true,
                headers: {
                  ...getTenantHeaders(),
                },
              })
              .auth(null, null, true, getToken('id_token'));

            // clear last notification
            await rp
              .delete(`${config.api.url}/${config.api.version}/notification/${device.serial}`, {
                body: {},
                json: true,
                authorization: true,
                resolveWithFullResponse: true,
                headers: {
                  ...getTenantHeaders(),
                },
              })
              .auth(null, null, true, getToken('id_token'));
          }
        }

        // discharge patient from bed
        await rp
          .post(`${config.api.url}/${config.api.version}/bed/discharge`, {
            body: { id: bed.id },
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));

        // delete bed
        await rp
          .delete(`${config.api.url}/${config.api.version}/bed/${bed.id}`, {
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
      }

      // update redis
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/subgroup/unassign/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteSubGroup(id) {
    this.loading = true;
    try {
      // delete subgroup
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/subgroup/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        const detail = { type: 'subgroup', subGroupId: id };
        await rp
          .post(`${config.api.url}/${config.api.version}/fetch`, {
            body: detail,
            json: true,
            authorization: true,
            resolveWithFullResponse: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async saveModules(data, id) {
    this.loading = true;
    try {
      const detail = {
        subGroups: data.map((val) => val.id),
        groupId: id,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/subgroup/assign`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async unAssignModules(id) {
    this.loading = true;
    try {
      const detail = { type: 'group', groupId: id };
      await rp
        .post(`${config.api.url}/${config.api.version}/fetch`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/subgroup/unassign/group/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new SubGroupStore();
